import { Preferences } from "@capacitor/preferences";

const HIGH_SCORE_KEY = "monspot_high_score";

// 최고점수 가져오는 함수
export async function getHighScore(): Promise<number> {
  try {
    const { value } = await Preferences.get({ key: HIGH_SCORE_KEY });
    if (!value) return 0;

    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  } catch (error) {
    console.error("Error retrieving high score:", error);
    return 0;
  }
}

// 최고점수 저장하는 함수
export async function setHighScore(score: number): Promise<void> {
  try {
    await Preferences.set({ key: HIGH_SCORE_KEY, value: String(score) });
  } catch (error) {
    console.error("Error setting high score:", error);
  }
}

// 점수 업데이트 함수 (새로운 점수가 최고점수보다 높으면 업데이트)
export async function updateHighScore(score: number): Promise<{
  bestScore: Number;
  isNewRecord: boolean;
}> {
  const currentBest = await getHighScore();

  if (score > currentBest) {
    await setHighScore(score);
    return { bestScore: score, isNewRecord: true };
  }

  return {
    bestScore: currentBest,
    isNewRecord: false,
  };
}
